module.exports = __webpack_public_path__ + "img/hongly-logo.6133697d.png";